import React from 'react';
import styles from './LogsModal.module.css';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import ToClose from '../../components/ToClose/ToClose';

const LogsModal = () => {
  const dispatch = useDispatch();
  const logs = useSelector((state) => state.modal?.modalData);

  return (
    <div className={styles.overlay}>
      <div className={styles.logsContainer}>
        <div className={styles.header}>
          <span className={styles.title}>Change Logs</span>
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>
        <div className={styles.logsBody}>
          {logs ? (
            logs?.map((log, idx) => (
              <div className={styles.logEntry} key={idx}>
                <p className={styles.action}>{log.action}</p>
                <p className={styles.timestamp}>{log.timestamp}</p>
                <p className={styles.updatedBy}>
                  Updated By: <strong>{log.updatedBy}</strong>
                </p>
                <button className={styles.viewDetail}>View Detail</button>
                {idx !== logs.length - 1 && <hr className={styles.divider} />}
              </div>
            ))
          ) : (
            <div className={styles.logEntry}>No Data Found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogsModal;
